module.exports = __webpack_public_path__ + "media/images/notes-901e22a187fcadaa1895dcf97dc7159a.svg";